import { render } from "./SelectLink.vue?vue&type=template&id=08ffdab5&scoped=true"
import script from "./SelectLink.vue?vue&type=script&lang=js"
export * from "./SelectLink.vue?vue&type=script&lang=js"

import "./SelectLink.vue?vue&type=style&index=0&id=08ffdab5&lang=scss&scoped=true"

import exportComponent from "D:\\digitalnewspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ffdab5"]])

export default __exports__